// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3005977","239":"d9d04dfb","667":"5ca1bb4f"}[chunkId] + ".chunk.js";
};